import React from 'react';

const N = '#0A2540';
const E = '#7C4DFF';

const edu = [
  { degree: 'BSc Accountancy',                          institution: 'Technical University of Kenya',     year: '2021', icon: '🎓' },
  { degree: 'Career Essentials in Project Management',  institution: 'Microsoft',                         year: '2025', icon: '🏆' },
  { degree: 'Scrum Product Owner',                      institution: 'International Scrum Institute',     year: '2022', icon: '📋' },
  { degree: 'Leadership & Management',                  institution: 'University of Washington, Seattle', year: '2022', icon: '🌐' },
  { degree: 'Financial Modelling & Valuation Analysis', institution: 'Corporate Finance Institute',       year: '2022', icon: '📊' },
  { degree: 'Business Intelligence & Data Analysis',    institution: 'Corporate Finance Institute',       year: '2022', icon: '💡' },
];

export default function Education() {
  return (
    <section id="education" className="section section-alt">
      <div className="container">
        <div className="section-header">
          <h2>Education & Certifications</h2>
          <div className="section-divider" />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
          {edu.map((e, i) => (
            <div key={i} className="card" style={{ padding: 24 }}>
              <div style={{ fontSize: '2rem', marginBottom: 12 }}>{e.icon}</div>
              <h4 style={{ color: N, fontSize: '0.95rem', fontWeight: 700, marginBottom: 6 }}>{e.degree}</h4>
              <p style={{ color: '#718096', fontSize: '0.85rem', marginBottom: 14 }}>{e.institution}</p>
              {/* Year badge — navy fill */}
              <span style={{
                background: N, color: '#fff',
                padding: '3px 12px', borderRadius: 20,
                fontSize: '0.78rem', fontWeight: 700,
              }}>
                {e.year}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { #education .container > div:last-child { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 480px) { #education .container > div:last-child { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
